import {useEffect, useState} from "react";
import useMediaQuery from "./hooks/useMediaQuery";
import {motion} from "framer-motion";
import {Route, BrowserRouter as Router, Routes} from "react-router-dom";

import Navbar from "./scenes/Navbar";
import DotGroup from "./scenes/DotGroup";
import Instructions from "./scenes/Instructions";
import FAQ from "./scenes/FAQ";
import Contact from "./scenes/Contact";

import Footer from "./scenes/Footer";
import PrivacyPolicy from "./scenes/PrivacyPolicy";
import LandingV2 from "./scenes/LandingV2";
import Features from "./scenes/Features";

import "./App.css"; // Import external CSS file

function App() {
    const [selectedPage, setSelectedPage] = useState("home");
    const [isTopOfPage, setIsTopOfPage] = useState(true);
    const isDesktop = useMediaQuery("(min-width: 1060px)");
    const isAboveMd = useMediaQuery("(min-width: 768px)");

    useEffect(() => {
        const handleScroll = () => {
            console.log('scrolling')
            if (window.scrollY === 0) {
                setIsTopOfPage(true);
                setSelectedPage("home");
            } else {
                setIsTopOfPage(false);
            }
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
            <Router>
                <Navbar
                    isTopOfPage={isTopOfPage}
                    selectedPage={selectedPage}
                    setSelectedPage={setSelectedPage}
                />
                <div className=" lg:mt-20 xxs:mt-16">
                    <Routes>
                        <Route path="/privacy-policy" element={<PrivacyPolicy/>}/>
                        <Route
                            path="/"
                            element={
                                <>
                                    <div className="container full-height">
                                        {isDesktop && (
                                            <DotGroup
                                                selectedPage={selectedPage}
                                                setSelectedPage={setSelectedPage}
                                            />
                                        )}
                                        <motion.div
                                            margin="0 0 -200px 0"
                                            amount="all"
                                            onViewportEnter={() => setSelectedPage("home")}
                                        >
                                            <LandingV2 setSelectedPage={setSelectedPage}/>
                                        </motion.div>
                                    </div>

                                    <div className="container full-height">
                                        <motion.div
                                            margin="0 0 -200px 0"
                                            amount="all"
                                            onViewportEnter={() => setSelectedPage("features")}
                                        >
                                            <Features/>
                                        </motion.div>
                                    </div>

                                    {isAboveMd && (<div className="container full-height">
                                        <motion.div
                                            margin="0 0 -200px 0"
                                            amount="all"
                                            onViewportEnter={() => setSelectedPage("instructions")}
                                        >
                                            <Instructions/>
                                        </motion.div>
                                    </div>)}

                                    <div className="container full-height">
                                        <motion.div
                                            margin="0 0 -200px 0"
                                            amount="all"
                                            onViewportEnter={() => setSelectedPage("faq")}
                                        >
                                            <FAQ setSelectedPage={setSelectedPage}/>
                                        </motion.div>
                                    </div>
                                    <div className="container full-height">
                                        <motion.div
                                            margin="0 0 -200px 0"
                                            amount="all"
                                            onViewportEnter={() => setSelectedPage("contact")}
                                        >
                                            <Contact/>
                                        </motion.div>
                                    </div>

                                    <Footer
                                        selectedPage={selectedPage}
                                        setSelectedPage={setSelectedPage}
                                    />
                                </>
                            }
                        />
                    </Routes>
                </div>
            </Router>
        </>
    );
}

export default App;
